import { useMemo } from "react";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { useIsFairfleetAdmin } from "@/hooks/useIsFairfleetAdmin";
import { DiagnosticView } from "@/models/DiagnosticView";

export function useVisibleViews(views: DiagnosticView[]): DiagnosticView[] {
  const { me } = useGeotabClient();
  const isFairfleetAdmin = useIsFairfleetAdmin();

  return useMemo(() => {
    if (isFairfleetAdmin) return views;
    const userGroupIds = new Set((me?.companyGroups ?? []).map(g => g.id));
    return views.filter(v => {
      if (!v.groups || v.groups.length === 0) return true;
      return v.groups.some(g => userGroupIds.has(g.id));
    });
  }, [views, me?.companyGroups, isFairfleetAdmin]);
}
